import { createApp } from 'vue'
import App from '@/app.vue'
import router from '@/router';
import { createPinia } from 'pinia'
import { IonicVue } from '@ionic/vue';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { initializeApplicationInsights } from '@/plugins/applicationInsights';
import { initializeSentry } from '@/plugins/sentry';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/**
 * Ionic Dark Mode
 * -----------------------------------------------------
 * For more info, please see:
 * https://ionicframework.com/docs/theming/dark-mode
 */

/* @import '@ionic/vue/css/palettes/dark.always.css'; */
/* @import '@ionic/vue/css/palettes/dark.class.css'; */
// import '@ionic/vue/css/palettes/dark.system.css';

/* Theme variables */
import './theme/variables.css';
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate);

import * as IonComponents from '@ionic/vue';

const app = createApp(App)
  .use(IonicVue)
  .use(pinia)
  .use(router);

const appInsights = initializeApplicationInsights(router);
const sentry = initializeSentry(app);

app.config.errorHandler = (err, instance, info) => {
  if (appInsights) {
    appInsights.trackException({
      exception: err instanceof Error ? err : new Error(String(err)),
      properties: {
        source: 'vue.errorHandler',
        component: instance?.$options?.name || 'unknown-component',
        info,
      },
    });
  }

  if (sentry) {
    sentry.captureException(err, {
      tags: {
        source: 'vue.errorHandler',
      },
      extra: {
        info,
      },
    });
  }

  console.error(err);
};

Object.keys(IonComponents).forEach((key) => {
  if (/^Ion[A-Z]\w+$/.test(key)) {
    const component = IonComponents[key];
    if (component) {
      app.component(key, component);
    }
  }
});

router.isReady().then(() => {
  app.mount('#app');
}); 